/* KRUX Shipping Gauge v3 — live cart data (Storefront 2.0 reliability fix)
   Fixes vs v2: no-store cart fetch (in-app browsers cached /cart.js), latest-response-wins
   instead of dropping overlapping fetches, refresh driven by the real /cart/add|change|update
   responses (via a shared fetch hook) instead of a single 700ms guess, plus the Horizon
   'cart:update' event. */
(function () {
  'use strict';

  var COUNTRY_THRESHOLDS = { AU: 9900, NZ: 19900 }; // cents
  var DEFAULT_THRESHOLD = 9900;
  var ARC_CIRC   = 1727.876; // 2 * Math.PI * 275
  var ARC_CLASSES = ['krux-gauge__arc-glow', 'krux-gauge__arc-fill', 'krux-gauge__arc-core'];

  function getActiveCountry() {
    var input = document.querySelector('input[name="country_code"]');
    return input ? input.value : null;
  }

  function getThreshold() {
    var country = getActiveCountry();
    if (country && COUNTRY_THRESHOLDS.hasOwnProperty(country)) {
      return COUNTRY_THRESHOLDS[country];
    }
    return DEFAULT_THRESHOLD;
  }

  function stageLabel(remaining, threshold) {
    if (remaining <= 0) return 'FREE SHIPPING UNLOCKED';
    var pct = remaining / threshold;
    if (pct <= 0.15) return 'ON DECK';
    if (pct <= 0.30) return 'ON APPROACH';
    if (pct <= 0.60) return 'BUILDING MOMENTUM';
    return 'SETTING SAIL';
  }

  function renderGauges(cart) {
    var threshold = getThreshold();
    var total     = cart.total_price;
    var remaining = Math.max(0, threshold - total);
    var progress  = Math.min(1, total / threshold);
    var offset    = parseFloat((ARC_CIRC * (1 - progress)).toFixed(2));
    var unlocked  = remaining === 0;
    var stage     = stageLabel(remaining, threshold);
    var amtText   = unlocked ? '✓' : '$' + Math.ceil(remaining / 100);
    var sfxText   = unlocked ? '' : 'TO GO';

    document.querySelectorAll('[data-krux-gauge]').forEach(function (el) {
      ARC_CLASSES.forEach(function (cls) {
        var c = el.querySelector('.' + cls);
        if (c) c.style.strokeDashoffset = offset;
      });

      el.classList.toggle('krux-unlocked', unlocked);

      var amountEl = el.querySelector('.krux-gauge__amount');
      var suffixEl = el.querySelector('.krux-gauge__suffix');
      var stageEl  = el.querySelector('.krux-gauge__stage');
      if (amountEl) amountEl.textContent = amtText;
      if (suffixEl) suffixEl.textContent = sfxText;
      if (stageEl)  stageEl.textContent  = stage;
    });

    var landingGauge = document.querySelector('.krux-landing-gauge');
    if (landingGauge) {
      landingGauge.classList.toggle('has-items', cart.item_count > 0);
    }
  }

  // Latest-response-wins: every request is allowed; only the newest result is rendered.
  var seq = 0;
  function fetchCart() {
    var mine = ++seq;
    fetch('/cart.js?_=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (mine === seq) renderGauges(data); })
      .catch(function () {});
  }

  // Shared hook: refresh as soon as a real cart mutation request completes.
  function hookCartFetch(cb) {
    if (!window.__kruxCartHooks) {
      window.__kruxCartHooks = [];
      var orig = window.fetch;
      window.fetch = function (input) {
        var url = '';
        try { url = typeof input === 'string' ? input : ((input && input.url) || ''); } catch (e) {}
        var p = orig.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          p.then(function () {
            window.__kruxCartHooks.forEach(function (h) { try { h(); } catch (e) {} });
          }).catch(function () {});
        }
        return p;
      };
    }
    window.__kruxCartHooks.push(cb);
  }
  hookCartFetch(function () { fetchCart(); setTimeout(fetchCart, 600); });

  fetchCart();

  ['cart:update', 'cart:updated', 'cart-update', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, fetchCart);
  });

  new MutationObserver(fetchCart).observe(document.body, {
    subtree: true,
    attributeFilter: ['data-cart-quantity', 'data-total-price']
  });

  // Fallback for non-fetch (full page) add-to-cart forms.
  document.addEventListener('submit', function () {
    setTimeout(fetchCart, 700);
    setTimeout(fetchCart, 2000);
  });

  // Returning via back/forward cache (common in in-app browsers) — refresh stale state.
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart(); });

  /* ─── Nav gauge click behaviour ─── */
  var REDLINE_ID = 'shop-redline';
  var HEADER_CLEARANCE = 90;

  function isHomepage() {
    return window.location.pathname === '/' || window.location.pathname === '';
  }

  function scrollToRedline() {
    var target = document.getElementById(REDLINE_ID);
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_CLEARANCE;
    window.scrollTo({ top: top, behavior: 'smooth' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.krux-nav-gauge-wrap');
    if (!trigger) return;
    e.preventDefault();
    if (isHomepage()) {
      scrollToRedline();
    } else {
      window.location.href = '/#' + REDLINE_ID;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var trigger = e.target.closest('.krux-nav-gauge-wrap');
    if (!trigger) return;
    e.preventDefault();
    if (isHomepage()) {
      scrollToRedline();
    } else {
      window.location.href = '/#' + REDLINE_ID;
    }
  });

  if (isHomepage() && window.location.hash === '#' + REDLINE_ID) {
    window.addEventListener('load', function () {
      setTimeout(scrollToRedline, 200);
    });
  }

})();
